// 환자 동의 버전 — 서버 functions/lib/clinic-patients.js(CONSENT_VERSION·ACCEPTED_CONSENT_VERSIONS·NOTIFY/DOCS_DEFAULT_VERSIONS)와 동기.
// 서버 주석 "웹 consentVersions.js 와 동기"의 웹 쪽 파일 (2026-09-16 신설 — 이전에는 웹에 버전 상수가 없었음).
// 웹은 환자 등록을 받지 않으므로(앱 전용) 이 값은 치과 화면 표시·판정 보조용이다. 최종 판정은 항상 서버 응답값(record.docs·record.notify).
//   cp-1.4 (정본 docs/환자동의_문안_cp-1.4_정본_2026-09-16.md): 서류 사본 전달이 필수 민감정보 동의에 포함 — 신규 레코드 docsPref(기본 켜짐).
//   cp-1.3: 구현·배포 전 cp-1.4 로 대체 → 허용 목록에서 제외(서버와 동일, 운영 레코드 0건 전제).
//   cp-1.5 (정본 docs/환자동의_문안_cp-1.5_정본_2026-10-01.md): 필수 3본문·해시는 cp-1.4와 바이트 동일, [선택] recall(독립 버전 recall-1.0) 추가 — 판정 집합은 cp-1.4와 같다(서버 2026-10-01 동기).

//   cp-1.6 (2026-10-02 장착 후 확인 등록 판) · cp-1.7 (2026-10-04 덴클 케어 1차 — 서류·재내원·장착 후 확인 없는 판, 케어 등록은 전부 cp-1.7):
//     2026-10-17 점검 P1-2 — 웹 목록에 빠져 앱 등록 환자 전원이 「(확인 필요)」로 보이던 것을 서버 목록과 맞춤(서버 clinic-patients.js ACCEPTED_CONSENT_VERSIONS 등 3목록).
export const CONSENT_VERSION = 'cp-1.4';
export const ACCEPTED_CONSENT_VERSIONS = ['cp-1.1', 'cp-1.2', 'cp-1.4', 'cp-1.5', 'cp-1.6', 'cp-1.7'];
// 알림이 동의 항목이 아니라 등록 시 기본 안내(notifyPref)인 버전
export const NOTIFY_DEFAULT_VERSIONS = ['cp-1.3', 'cp-1.4', 'cp-1.5', 'cp-1.6', 'cp-1.7'];
// 서류 사본 전달이 필수 sensitive 본문에 포함된 버전(docsPref) — cp-1.7(케어)은 서류 없는 판이라 넣지 않는다(서버와 동일)
export const DOCS_DEFAULT_VERSIONS = ['cp-1.4', 'cp-1.5', 'cp-1.6'];
// 기존 레코드의 서류 선택 동의(치과 요청·설정 켜기) 기록 버전 — 본문 판 기준(정본 cp-1.4 §4-2)
export const DOCS_ITEM_CONSENT_VERSION = 'cp-1.2';

export const isAcceptedConsentVersion = (v) => ACCEPTED_CONSENT_VERSIONS.includes(v);

// 서버 effectiveNotify 와 같은 규칙 — notifyPref 있으면 그 값, 없으면 consents.notify
export function effectiveNotify(rec) {
    if (!rec) return false;
    if (rec.notifyPref && typeof rec.notifyPref.enabled === 'boolean') return rec.notifyPref.enabled === true;
    return rec.consents?.notify?.agreed === true;
}

// 서버 effectiveDocs 와 같은 규칙 — docsPref 있으면 enabled && sensitive 판이 서류 포함 판, 없으면 consents.docs
export function effectiveDocs(rec) {
    if (!rec) return false;
    if (rec.docsPref && typeof rec.docsPref.enabled === 'boolean') {
        return rec.docsPref.enabled === true && DOCS_DEFAULT_VERSIONS.includes(rec.consents?.sensitive?.version);
    }
    return rec.consents?.docs?.agreed === true;
}
